import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

// TEMPORAIRE, propre à La Vitrine Médicale. Pour le retirer : supprimer ce dossier, sa balise dans rental-contract.component.html, vitrinePayerId et visibleTerms de RentalAddLineComponent.

// Clients « services d'hospitalisation » (ids de la prod) : chez eux on cache les contrats Sécu, partout ailleurs les contrats Hospitalisation.
export const HOSPITAL_PAYERS: number[] = [
  4089,    // SANTE ET SOLIDARITE DU VAR · LA GARDE
  29063,   // SANTE ET SOLIDARITE DU VAR · LA SEYNE SUR MER
  28618,   // SANTE ET SOLIDARITE DU VAR · HAD BRIGNOLES
  87767,   // SANTE ET SOLIDARITE DU VAR (LA GARDE)
  31211,   // SANTE SOLIDARITE DU VAR · BIS (LA GARDE)
  34497,   // SANTÉ SOLIDARITÉ DU VAR (LA VALETTE DU VAR)
  58552,   // SSV TOULON
  27085,   // HAD CAP DOMICILE (LA SEYNE SUR MER)
  79900,   // HAD CAP DOMICILE (LA GARDE)
  87430,   // HAD CAP DOMICILE (LA GARDE)
  40872,   // HAD LA GARDE
  57811,   // HAD LA SEYNE SUR MER
  1728,    // HAD DU VAR
  31991,   // HAD DRAGUIGNAN
  61914,   // HAD de Nice et Région
  63749,   // HAD NICE
  73774,   // HAD SSIAD · DE LA CIOTAT
  63727,   // Santé Solidarité des Bouches Du Rhône
];

export function isHospitalPayer(payerId: number | string | null | undefined): boolean {
  return HOSPITAL_PAYERS.includes(Number(payerId));
}

const fold = (s: string | null | undefined) => (s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

// Contrat caché pour ce payeur facturé (null = le patient paie) : « Sécu… » chez un service d'hospitalisation, « Hospitalisation… » ailleurs.
export function vitrineHidesTerms(termsName: string | null | undefined, payerId: number | string | null): boolean {
  return fold(termsName).startsWith(isHospitalPayer(payerId) ? 'secu' : 'hospitalisation');
}

// Articles les plus loués sous la carte « Livrer un matériel » ; gabarit fixe, généré par ~/Téléchargements/vitrine-articles-loues.ts.
@Component({
  selector: 'app-vitrine-rental-pick',
  templateUrl: './vitrine-rental-pick.component.html',
  styleUrls: ['./vitrine-rental-pick.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
})
export class VitrineRentalPickComponent {
  @Input() payerId: number | string | null = null;   // payeur facturé distinct du patient, sinon null
  @Output() pick = new EventEmitter<number>();   // id de l'article, chargé dans la carte comme par la recherche

  showOthers = false;

  get hospital(): boolean {
    return isHospitalPayer(this.payerId);
  }
}
